/**
 * Created by andrey on 22.01.2021.
 */

const Map2dAdviceView = function (advice, scene) {
    this.advice = advice;

    this.advice.on("showHint", this.showHint.bind(this), scene);
    this.advice.on("hideHint", this.hideHint.bind(this), scene);
};

Map2dAdviceView.prototype.findAdviceTarget = function (parent, targets) {
    targets = cleverapps.toArray(targets);

    let children = cleverapps.toArray(parent);
    while (children.length > 0) {
        const node = children.shift();

        if (node.adviceTarget && targets.some((target) => target === node.adviceTarget)) {
            return node;
        }

        children = children.concat(node.children);

        if (node.additionalViews) {
            Object.keys(node.additionalViews).forEach((type) => {
                children.push(node.additionalViews[type]);
            });
        }
    }
};

Map2dAdviceView.prototype.parseMove = function (move) {
    const params = {};
    let node;

    if (move.unitAdditionalView) {
        const unit = Map2d.currentMap.getUnit(move.cells[0].x, move.cells[0].y);
        const unitView = unit.onGetView();
        const unitAdditionalView = unitView && unitView.getAdditionalView("extended_ingredients");
        if (unitAdditionalView) {
            node = this.findAdviceTarget(unitAdditionalView, move.unitAdditionalView);
            if (!node) {
                return params;
            }
        }
    }

    if (move.window) {
        const window = cleverapps.focusManager.currentWindow();
        if (window) {
            node = this.findAdviceTarget(window, move.window);
            if (!node) {
                return params;
            }
        }
    }

    if (move.fogView) {
        const fog = Map2d.currentMap.getFog(move.cells[0].x, move.cells[0].y);
        const fogView = fog && fog.fogBlock.onGetView();
        if (fogView) {
            node = this.findAdviceTarget(fogView, move.fogView);
        }
    }

    if (move.unitView) {
        const units = Map2d.currentMap.getMapView().listTiles(Map2d.LAYER_UNITS, move.cells[0].x, move.cells[0].y);
        if (units) {
            node = this.findAdviceTarget(units, move.unitView);
        }
    }

    if (node) {
        if (move.resources) {
            params.finger = { dragTargets: [node].concat(move.resources), getPayload: node.createAdviceIcon && node.createAdviceIcon.bind(node) };
        } else {
            params.finger = { clickTarget: node };
        }
        if (move.fogView && move.arrow) {
            params.arrow = { node };
        }
        return params;
    }

    if (move.arrow) {
        params.arrow = { cell: move.arrow };
    }
    if (move.fingerDrag) {
        params.finger = { dragTargets: move.fingerDrag };
    }
    if (move.highlight) {
        params.highlight = { cells: move.highlight };
    } else if (move.mergeCluster) {
        params.highlightMerge = { cells: move.mergeCluster };
    }
    if (move.outline) {
        params.outline = { cell: move.outline };
    }

    return params;
};

Map2dAdviceView.prototype.showHint = function (move, options) {
    options = options || {};
    const moveParams = this.parseMove(move);

    this.showArrow(moveParams, options.arrow);
    this.showFinger(moveParams, options.finger);
    if (options.highlight !== false) {
        this.showHighlight(moveParams);
    }
    if (options.highlightMerge !== false) {
        this.showHighlightMerge(moveParams);
    }
    this.showOutline(moveParams);
};

Map2dAdviceView.prototype.showArrow = function (moveParams, options) {
    this.removeArrow();

    if (moveParams.arrow && options !== false) {
        options = options || {};
        moveParams.arrow.delay = options.delay;
        moveParams.arrow.arrowType = options.arrowType;
        this.createArrow(moveParams.arrow);
    }
};

Map2dAdviceView.prototype.showFinger = function (moveParams, options) {
    options = options || {};
    FingerView.remove(this.hintFinger);
    delete this.hintFinger;
    if (!moveParams.finger) {
        return;
    }

    if (moveParams.finger.clickTarget) {
        this.hintFinger = FingerView.hintTap(moveParams.finger.clickTarget, { repeatDelay: options.repeatDelay });
    }
    if (moveParams.finger.dragTargets) {
        if (moveParams.finger.getPayload || moveParams.finger.dragTargets.length > 2) {
            this.hintFinger = FingerView.hintDrag(moveParams.finger.dragTargets, {
                getPayload: moveParams.finger.getPayload,
                repeatDelay: options.repeatDelay,
                delay: options.delay
            });
        } else if (moveParams.finger.dragTargets.length === 2) {
            this.hintFinger = FingerView.hintSwipe(
                moveParams.finger.dragTargets[0],
                moveParams.finger.dragTargets[1],
                {
                    repeatDelay: options.repeatDelay,
                    delay: options.delay
                }
            );
        } else if (moveParams.finger.dragTargets.length === 1) {
            this.hintFinger = FingerView.hintTap(
                moveParams.finger.dragTargets[0],
                {
                    repeatDelay: options.repeatDelay,
                    delay: options.delay
                }
            );
        }
    }
};

Map2dAdviceView.prototype.showHighlight = function (moveParams) {
    if (this.highlightUnits) {
        this.highlightUnits.forEach((unit) => {
            unit.unhighlight();
        });
        delete this.highlightUnits;
    }

    if (moveParams.highlight) {
        this.highlightUnits = moveParams.highlight.cells.map((cell) => Map2d.currentMap.getUnit(cell.x, cell.y)).filter((unit) => {
            if (unit) {
                unit.highlight();
                return true;
            }
            return false;
        });
    }
};

Map2dAdviceView.prototype.showHighlightMerge = function (moveParams) {
    if (this.mergeHintUnit) {
        const mergeComponent = this.mergeHintUnit.findComponent(MergeComponent);
        mergeComponent.unhighlightMerge();
        delete this.mergeHintUnit;
    }

    if (moveParams.highlightMerge) {
        const initiator = moveParams.highlightMerge.cells[0];
        const unit = this.mergeHintUnit = Map2d.currentMap.getUnit(initiator.x, initiator.y);
        const mergeComponent = unit.findComponent(MergeComponent);
        mergeComponent.highlightMerge(moveParams.highlightMerge.cells);
    }
};

Map2dAdviceView.prototype.createArrow = function (params) {
    const cell = params.cell;
    let styles = cleverapps.styles.Map2dAdviceView.straightArrow;

    const unit = cell && Map2d.currentMap.getUnit(cell.x, cell.y);
    const unitView = unit && unit.onGetView();
    if (unit && unit.prizes || unitView && unitView.getAdditionalView("ingredients")) {
        styles = cleverapps.styles.Map2dAdviceView.skewArrow;
    }

    if (params.arrowType && cleverapps.styles.Map2dAdviceView[params.arrowType]) {
        styles = cleverapps.styles.Map2dAdviceView[params.arrowType];
    }

    const animations = Map2d.currentMap.getMapView().animations;
    const arrow = this.arrow = new cc.Sprite(bundles.merge_animations.frames.tutorial_arrow);
    animations.addChild(arrow);

    const pos = params.node
        ? animations.convertToNodeSpace(params.node.parent.convertToWorldSpace(params.node.getPosition()))
        : Map2d.currentMap.getMapView().getUnitCenterPos(cell.x, cell.y);
    arrow.setPosition(pos.x + styles.offsetX, pos.y + styles.offsetY);
    arrow.setRotation(styles.rotation);

    const launch = function () {
        arrow.runAction(new cc.RepeatForever(
            new cc.Sequence(
                new cc.MoveBy(0.5, -styles.deltaX, styles.deltaY).easing(cc.easeInOut(1.7)),
                new cc.MoveBy(0.5, styles.deltaX, -styles.deltaY).easing(cc.easeInOut(1.7))
            )
        ));
    };

    arrow.setVisible(false);
    arrow.runAction(new cc.Sequence(
        new cc.DelayTime(params.delay || 0),
        new cc.Show(),
        new cc.CallFunc(launch)
    ));
};

Map2dAdviceView.prototype.showOutline = function (params) {
    this.removeOutline();

    if (params.outline) {
        const cell = params.outline.cell;
        const unit = Map2d.currentMap.getUnit(cell.x, cell.y);
        const unitView = unit && unit.onGetView();
        if (unitView) {
            this.outlineUnit = unit;
            unitView.outline();
        }
    }
};

Map2dAdviceView.prototype.hideHint = function () {
    FingerView.remove(this.hintFinger);
    this.hintFinger = undefined;

    if (this.mergeHintUnit) {
        const mergeComponent = this.mergeHintUnit.findComponent(MergeComponent);
        mergeComponent.unhighlightMerge();
        delete this.mergeHintUnit;
    }

    if (this.highlightUnits) {
        this.highlightUnits.forEach((unit) => {
            unit.unhighlight();
        });
        delete this.highlightUnits;
    }

    this.removeArrow();
    this.removeOutline();
};

Map2dAdviceView.prototype.removeArrow = function (silent) {
    if (this.arrow) {
        if (silent) {
            this.arrow.removeFromParent();
            this.arrow = undefined;
        } else {
            this.arrow.runAction(new cc.Sequence(
                new cc.FadeOut(0.2),
                new cc.RemoveSelf()
            ));
            this.arrow = undefined;
        }
    }
};

Map2dAdviceView.prototype.removeOutline = function () {
    if (this.outlineUnit && this.outlineUnit.onGetView()) {
        this.outlineUnit.onGetView().outline(true);
    }
};

Map2dAdviceView.listRects = function (data, options) {
    options = options || {};

    const move = options.move || Map2d.currentMap.advice.getCurrentMove() || {};
    const delta = options.delta || cc.p(0, 0);
    const cells = [];

    if (move.cells) {
        cells.push(...move.cells);
    }

    if (move.mergeCluster) {
        cells.push(...move.mergeCluster);
    }

    const rects = cells.map((coords) => {
        const unit = Map2d.currentMap.getUnit(coords.x, coords.y);
        let rect;
        if (unit) {
            Map2d.currentMap.showLayerTile(Map2d.LAYER_UNITS, coords.x, coords.y);
            const unitView = unit.onGetView();

            rect = unitView.getSceneBoundingBox();

            unitView.listAdditionalViews().forEach((view) => {
                if (view.view) {
                    rect = cc.rectUnion(rect, view.view.getSceneBoundingBox());
                    if (view.view.button) {
                        rect = cc.rectUnion(rect, view.view.button.getSceneBoundingBox());
                    }
                }
            });
        }

        const fog = Map2d.currentMap.getFog(move.cells[0].x, move.cells[0].y);
        const fogView = fog && fog.fogBlock.onGetView();
        if (fogView) {
            rect = fogView.getSceneBoundingBox();
            if (fogView.openerWindow) {
                rect = cc.rectUnion(rect, fogView.openerWindow.getSceneBoundingBox());
                if (fogView.openerWindow.button) {
                    rect = cc.rectUnion(rect, fogView.openerWindow.button.getSceneBoundingBox());
                }
            }
        }

        if (rect) {
            const zoom = Map2dScroller.currentScroller.getScrollView().zoom;
            const padding = cc.padding(cleverapps.styles.Map2dAdviceView.mapRectOffset);
            rect = cc.rectAddPadding(rect, cc.multPadding(padding, zoom));
        }

        return rect;
    }).filter(Boolean);

    const advice = cleverapps.Scenes.GetSceneComponent(Map2dLocationSceneComponent).advice;
    const arrow = advice && advice.arrow;
    if (arrow) {
        rects.push(arrow.getSceneBoundingBox());
    }

    rects.forEach((rect) => {
        rect.x -= delta.x;
        rect.y -= delta.y;
    });

    if (data.controls) {
        const scene = cleverapps.Scenes.GetRunningScene();
        const controls = cleverapps.toArray(data.controls);
        if (controls.includes("toolbar")) {
            const toolbarBox = ComponentUtils.findChildByName(scene, "toolbar").getBoundingBox();
            rects.push(toolbarBox);
        }

        if (controls.some((control) => control.includes("MenuBar"))) {
            // The menubar hangs off the up menu now, not the scene, so its rect has to be taken in
            // scene space to sit alongside the others.
            const menuBar = ComponentUtils.findComponentByName(scene, "UpMenuController").getMenuBar();
            if (menuBar) {
                rects.push(menuBar.getSceneBoundingBox());
            }
        }
    }

    return rects;
};

cleverapps.styles.Map2dAdviceView = {
    mapRectOffset: {
        left: 120, right: 120, top: 120, bottom: 120
    },

    straightArrow: {
        rotation: 0,
        offsetX: -5,
        offsetY: 120,
        deltaX: 0,
        deltaY: 60
    },

    skewArrow: {
        rotation: -60,
        offsetX: -110,
        offsetY: 70,
        deltaX: 50,
        deltaY: 29
    },

    sideArrow: {
        rotation: 90,
        offsetX: 110,
        offsetY: 30,
        deltaX: -50,
        deltaY: 0
    }
};
